const url = "/api/v1/trial_offers";

// Redemption is driven by EITHER a manually typed `code` (the ActivateCard
// form) OR the partner QR carry-through (the activation page's auto-redeem,
// which sends an empty body — the server resolves the carried activation code
// from the user's onboarding source). So `code` is optional.
export interface TrialOffersUpdateParams {
  code?: string;
}

export const trialOffersUpdateQuery = (params: TrialOffersUpdateParams) => ({
  url,
  method: "PATCH",
  body: params,
});

interface ValidResponse {
  id: string;
  key: "valid";
  message: string;
}

interface OtherResponse {
  key: "invalid" | "already_used";
  message: string;
}

interface TrialOfferSerializer {
  data: {
    attributes: ValidResponse | OtherResponse;
  };
}

export type TrialOffersUpdateResponse = TrialOfferSerializer;
